import { atom, useRecoilState } from 'recoil'
import { useTeacherInfo } from './teacher-info'

export const globalOkAtom = atom({
  key: 'global-ok',
  default: false,
})

export const isLoginAtom = atom({
  key: 'is-login',
  default: false,
})

export function useGlobalState() {
  const [globalOk, setGlobalOk] = useRecoilState(globalOkAtom)
  const [isLogin, setIsLogin] = useRecoilState(isLoginAtom)
  const teacherInfo = useTeacherInfo()
  const updateGlobalState = async () => {
    const [res] = await Promise.all([teacherInfo.updateTotalTeacherInfo()])
    setGlobalOk(true)
    return {
      teacherInfo: res,
    }
  }
  return {
    globalOk,
    isLogin,
    setIsLogin,
    teacherInfo,
    updateGlobalState,
  }
}
